<template>
<div class="card shadow-sm">
      <div class="card-body pb-3">
        
          <div class="row">
            <div class="col-5"><div class="section-heading pb-3">Top pages</div></div>
            <div class="col-7 text-right"><small><i :class="`fas ${loadIcon} mr-2`"></i><a href="#/" @click="switchData">Show {{showText}}</a></small></div>
          </div>

        <div v-if="loading" class="text-center">
        <i class="fas fa-spinner fa-spin fa-1x"></i>
      </div>

      <div v-else-if="rows.length == 0" class="text-center">No data yet</div>

      <span v-else>

        <table class="table">
          <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="80%">Name</th>
                  <th class="first-right text-right pr-3" width="20%">Visitors</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(row, index) in displayedRows" :key="index.id">
              <td class="pl-3">
                <small><i class="fas fa-link mr-2"></i><a :href="row.name" :title="row.name" target="_blank">{{truncate(removeDomain(row.name), 40)}}</a></small>
              </td>
              <td class="pr-3 text-right"><small>{{row.count}}</small></td>
            </tr>
          </tbody>
        </table>

        </span>

    </div>
</div>
</template> 

<script>
export default {
  props: ['site_id'],
  data() {
    return {
      rows: [],
      loading: true,
      dataLimit: 6,
      showAll: false,
    };
  },

  created() {
    this.getData();

    Echo.channel("site_" + this.site_id)
      .listen("SiteVisitor", () => {
        this.getData();
      });
  },

  computed: {
    displayedRows() {
      return this.showAll ? this.rows : this.rows.slice(0, this.dataLimit);
    },

    showText() {
      return this.showAll ? 'less' : 'more';
    },

    loadIcon() {
      return this.showAll ? 'fa-chevron-up' : 'fa-chevron-down';
    },
  },

    methods: {

      switchData() {
      this.showAll = !this.showAll;
    },

        getData() {

      axios.post(`/websites/data`, {
        site_id: this.site_id,
        type: 'url',
      }).
      then((response) => {
        this.rows = response.data;
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
      }).finally(() => {
        this.loading = false;
      });

    },
    }

}
</script>